// extracted by mini-css-extract-plugin
export default {"wrapper":"Summary_wrapper__osany","summaryGrapCard":"Summary_summaryGrapCard__l8Jva","summaryGraphCardCol":"Summary_summaryGraphCardCol__JvnaJ"};